import Vue from 'vue'
import VariableHelpers from '@/assets/js/variableHelpers.js'
import variableHelpers from './variableHelpers'

const operators = require('@/assets/js/operators.json')
// const expressionRegex = /({.*})(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)(.*)/g // Added "contains" lets see if it causes problems
const expressionRegex = /({.*})\s?(!=NULL|=NULL|>=|!=|<=|=|>|<|contains|notcontains)\s?(.*)/g  // Added "contains" lets see if it causes problems

class FormattedVariable {
	leftHandVariable = null
	operator = null
	rightHandVariable = null
	rightHandConstant = null
    customExpression = null
    
    // New
    leftHandFormattedVariable = null
    rightHandFormattedVariable = null
    //

	constructor (expression, allVariables, formattedLeft, formattedRight) {
        let isStandard = this.extractExpressionComponents(expression, allVariables, formattedLeft, formattedRight)
		if (!isStandard || allVariables === 'custom') this.customExpression = expression
	}
	get expression () {
        let leftHand = '';
        let rightHand = '';
        if(this.leftHandVariable){
            if(this.leftHandFormattedVariable){this.leftHandFormattedVariable.name ? leftHand = this.leftHandFormattedVariable.name : leftHand = ''}
            else if(this.leftHandVariable){this.leftHandVariable.name ? leftHand = this.leftHandVariable.name : leftHand = ''}
        }
        if(this.rightHandVariable){
            if(this.rightHandFormattedVariable){this.rightHandFormattedVariable.name ? rightHand = this.rightHandFormattedVariable.name : rightHand = ''}
            else if(this.rightHandVariable){this.rightHandVariable.name ? rightHand = this.rightHandVariable.name : rightHand = ''}
        }
        if(this.rightHandConstant){rightHand = this.rightHandConstant}
        return leftHand + (this.operator ? this.operator.name : '') + rightHand
        // the old one
        // return (this.leftHandVariable ? this.leftHandVariable.name : '') + (this.operator ? this.operator.name : '') + ((this.rightHandVariable ? this.rightHandVariable.name : false) || this.rightHandConstant || '')
    }

	get isValid () {
		return this.leftHandVariable && this.operator && (this.rightHandVariable || (this.rightHandConstant != null && this.rightHandConstant.length))
	}
	// split up each components of an expression
	extractExpressionComponents(expression = '', allVariables, formattedLeft, formattedRight) {
        // get groups
        let groups = Array.from(expression.matchAll(expressionRegex))
		if (!groups.length || groups.length && groups[0].length != 4) { console.log('invalid expression: ' + expression); return false }
        else {
            groups = groups[0]
            if(["contains", "notcontains"].includes(groups[2]) && ["'", '"'].includes(groups[3].charAt(0)) && groups[3][0] == groups[3].slice(-1) ){    
                groups[3] = groups[3].slice(1,-1)
            }
            if (!this.setLeftHand(groups[1], allVariables, formattedLeft)) return false
            if (!this.setOperator(groups[2], this.leftHandVariable)) return false
            if (!this.setRightHand(groups[3], allVariables, formattedRight)) return false
            return true
            
        }
	}
    setLeftHand (content, allVariables, formattedLeft) {
        if(formattedLeft) {
            const formattedObject = this.formatVariable(content, formattedLeft[0], allVariables, true)
            Vue.set(this, 'leftHandFormattedVariable', formattedObject)
        }
        if(allVariables[content] || allVariables[VariableHelpers.removeFormatting(content)]) {
            Vue.set(this, 'leftHandVariable', allVariables[content] || allVariables[VariableHelpers.removeFormatting(content)])
            // Vue.set(this, 'leftHandFormattedVariable', allVariables[VariableHelpers.removeFormatting(content)] )
            return true
        }  else {
            if(allVariables === 'custom') {console.log('Can not set lefthand variable, expression is Custom')}
            else console.log('invalid expression, left hand variable unknown: ' + content)
            return false
        }
    }

	setOperator (content) {
        let operatorType;
        if(this.leftHandFormattedVariable){operatorType = this.leftHandFormattedVariable.type}
        else{operatorType = this.leftHandVariable.type}     
		let operator = operators.find(o => o.name === content && o.validFor.indexOf(operatorType.toLowerCase()) > -1)
		if (operator) {
			Vue.set(this, 'operator', operator)
			return true
		} else {
			console.log('invalid expression, invalid operator for variable type ' + this.leftHandVariable.type + ' provided: ' + content)
			return false
		}
	}

	setRightHand (content, allVariables, formattedRight) {
        if(formattedRight) {
            const formattedObject = this.formatVariable(content, formattedRight[0], allVariables, true)
            this.rightHandConstant = null
            Vue.set(this, 'rightHandFormattedVariable', formattedObject)
        }
		if (allVariables[content] || allVariables[VariableHelpers.removeFormatting(content)]) {
			this.rightHandConstant = null
			Vue.set(this, 'rightHandVariable', allVariables[content] || allVariables[VariableHelpers.removeFormatting(content)] )
			return true
		} else {
			Vue.set(this, 'rightHandVariable', null)
			Vue.set(this, 'rightHandConstant', content)
			return true
		}
	}

	setCustomExpression (expression) {
		this.customExpression = expression
		this.leftHandVariable = null
		this.operator = null
		this.rightHandVariable = null
		this.rightHandConstant = null
    }
    
    formatLeftHand(content, format, allVariables){
        const formattedObject = this.formatVariable(content, format, allVariables)

        console.log("LEFT HAND FORMAT" , formattedObject)
        Vue.set(this, 'leftHandFormattedVariable', formattedObject)
    }
    formatRightHand(content, format, allVariables){
        const formattedObject = this.formatVariable(content, format, allVariables)

        console.log("RIGHT HAND FORMAT" , formattedObject)
        Vue.set(this, 'rightHandFormattedVariable', formattedObject)
    }

    formatVariable (content, format, allVariables, dontFormat) {
        const formattedObject = Object.assign({}, allVariables[content])

        formattedObject.type = this.getFormattedType(format)
        formattedObject.name = dontFormat ? content : variableHelpers.insertFormatting(content, format.format);
        formattedObject.value = format.result
        return formattedObject        
    }
    getFormattedType(format){
        if(format.result.match(/^\d+$/) ) {console.log("Is a number") 
        return "number"}
        else{console.log("not a number - should return as string type")
        return "text"}
    }
}

export default FormattedVariable